import * as React from 'react'

import AppleCalendarModal from './AppleCalendar'
import { CobeeRedirect } from './CobeeRedirect'
import GoogleCalendarModal from './GoogleCalendar'
import IndeedModal from './Indeed'
import { Join } from './Join'
import LinkedInModal from './LinkedIn'
import OutlookCalendarModal from './OutlookCalendar'
import { Payflow } from './Payflow'
import { Slack } from './Slack'
import { Zapier } from './Zapier'
import { ZapierRedirect } from './ZapierRedirect'

const INTEGRATIONS_COMPONENTS = {
  indeed: IndeedModal,
  google_calendar: GoogleCalendarModal,
  apple_calendar: AppleCalendarModal,
  outlook_calendar: OutlookCalendarModal,
  zapier: Zapier,
  join: Join,
  linkedin: LinkedInModal,
  slack: Slack,
  gmail: ZapierRedirect,
  outlook: ZapierRedirect,
  breezy: ZapierRedirect,
  recruitee: ZapierRedirect,
  cobee: CobeeRedirect,
  payflow: Payflow,
} as const

// Since every integration should do a unique action, we are matching
// each of them with a unique component that handles it
interface Props {
  id: keyof typeof INTEGRATIONS_COMPONENTS
  onClose: () => void
}

const IntegrationModal = ({ id, onClose }: Props) => {
  if (!INTEGRATIONS_COMPONENTS[id]) {
    throw new Error(`Unkown id passed to IntegrationModal: ${id}`)
  }

  return React.createElement(INTEGRATIONS_COMPONENTS[id], {
    onClose,
  })
}

export default IntegrationModal
